// error reducer
export const SET_ERROR = 'SET_ERROR';
export const INIT_ERROR = 'INIT_ERROR';